// @ts-check
import Operator, { LogicalOperator } from './Operator';
import _ from 'lodash';

/**
 * @typedef {object} Condition
 * @property {number} lhs
 * @property {Operator} operator
 * @property {number} rhs
 * @property {LogicalOperator} logicalOperator
 */


/**
 *
 * @param {Condition} condition
 */
export const evaluateCondition = (condition) => {
  switch (condition.operator) {
    case Operator.EQUAL:
      return condition.lhs === condition.rhs;
    case Operator.NOT_EQUAL:
      return condition.lhs !== condition.rhs;
    case Operator.LESS_THAN:
      return condition.lhs < condition.rhs;
    case Operator.LESS_THAN_OR_EQUAL:
      return condition.lhs <= condition.rhs;
    case Operator.GREATER_THAN:
      return condition.lhs > condition.rhs;
    case Operator.GREATER_THAN_OR_EQUAL:
      return condition.lhs >= condition.rhs;
    default:
      return false;
  }
};

/**
*
* @param {Condition[]} conditions
*/
export const evaluateConditions = (conditions) => {
  let currentGroupResult = true;
  return _.reduce(conditions, (result, condition, index) => {
    // First index is always AND condition because we start with 'true'
    const logicalOperator = index === 0 ? LogicalOperator.AND : (condition.logicalOperator ?? LogicalOperator.AND);
    const conditionResult = evaluateCondition(condition);
    if (logicalOperator === LogicalOperator.AND) {
      currentGroupResult = currentGroupResult && conditionResult;
    } else if (condition.logicalOperator === LogicalOperator.OR) {
      currentGroupResult = currentGroupResult || conditionResult;
    }

    if (logicalOperator === LogicalOperator.AND) {
      result = currentGroupResult && result;
    } else if (logicalOperator === LogicalOperator.OR) {
      result = result || currentGroupResult;
    }
    return result;
  }, true);
};
